import type { PropertyType, SelectOption } from "@/types/ui";
import { DateTime } from "luxon";

export function deepCopy<T>(source: object): T {
    return JSON.parse(JSON.stringify(source)) as T;
}

export function cleanPayload<T>(source: object): T {
    const copy = deepCopy<T>(source);
    Object.keys(source).forEach((key) => {
        // @ts-expect-error TS can't handle this
        if (!source[key]) {
            delete copy[key as keyof T];
        }
    })
    return copy;
}

export function filteredObject<T>(source: object, allowedProperties: string[]): T {
    const copy = {} as T;
    Object.keys(source).forEach((key) => {
        if (allowedProperties.includes(key)) {
            // @ts-expect-error TS can't handle this
            copy[key as keyof T] = source[key];
        }
    })
    return copy;
}

export function getDefaultValueForType(type: PropertyType): any {
    switch (type) {
        case 'string':
            return '';

        case 'number':
            return null;

        case 'date':
            return '';

        case 'relation':
            return null;

        default:
            return null;
    }
}

export function getUnitsOfMeasurementOptions(): SelectOption<string>[] {
    return [
        { value: 'Kg', label: 'Kilogram [KG]' },
        { value: 'L15°', label: 'Volume [L15°]' },
    ];
}

export function lowercaseFirstLetter(str: string): string {
    if (!str) return str; // Handle empty string or null
    return str.charAt(0).toLowerCase() + str.slice(1);
}

export async function convertFileToBase64(file: File): Promise<string> {
    const buf = await file.arrayBuffer();
    const arr = new Uint8Array(buf);
    const str = arr.reduce((data, byte) => {
        return data + String.fromCharCode(byte);
    }, '');
    return btoa(str);
}

export function base64toBlob(data: string): Blob {
    // Cut the prefix `data:application/pdf;base64` from the raw base 64
    const base64WithoutPrefix = data.substr('data:application/pdf;base64,'.length);

    const bytes = atob(base64WithoutPrefix);
    let length = bytes.length;
    const out = new Uint8Array(length);

    while (length--) {
        out[length] = bytes.charCodeAt(length);
    }

    return new Blob([out], { type: 'application/pdf' });
};

export function getFormattedDate(value?: string | null, format?: string | null): string {
    if (!value) return '';
    if (!format) return DateTime.fromISO(value).toLocaleString({ year: 'numeric', month: '2-digit', day: '2-digit' });
    return DateTime.fromISO(value).toFormat(format);
}

export function numberToLocale(value?: number | null, minimumFractionDigits = 0, maximumFractionDigits = 3): string | undefined {
    if ([undefined, null].includes(value)) return '';
    if (value === 0) return '0';
    return value?.toLocaleString(localStorage.getItem('locale') || window.navigator.language, { minimumFractionDigits, maximumFractionDigits });
}

export function sleep(ms: number) {
    const end = Date.now() + ms;
    while (Date.now() < end) {
        // blockiert die Ausführung für ms Millisekunden
    }
}
